import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const CallBell = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 16 16"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <defs>
          <clipPath id="callBell__a">
            <rect
              x="0"
              y="0"
              width="16"
              height="16"
              rx="0"
            />
          </clipPath>
        </defs>
        <g clipPath="url(#callBell__a)">
          <path
            d="M1,11C1,10.8674002,1.052680016,10.7402,1.14644504,10.64645C1.24021494,10.5527,1.36739004,10.5,1.5,10.5L2,10.5L2,9.5C2.0018200999999998,7.9958,2.5678549,6.54705,3.586225,5.4400501000000006C4.6045952,4.333025,6.0012002,3.64832,7.5,3.52125L7.5,2.5L6.5,2.5C6.3674002,2.5,6.2402,2.44731998,6.14645,2.35355496C6.0527,2.25978494,6,2.13261008,6,2C6,1.86739004,6.0527,1.74021494,6.14645,1.64644504C6.2402,1.552680016,6.3674002,1.5,6.5,1.5L9.5,1.5C9.6325998,1.5,9.7598,1.552680016,9.85355,1.64644504C9.9473,1.74021494,10,1.86739004,10,2C10,2.13261008,9.9473,2.25978494,9.85355,2.35355496C9.7598,2.44731998,9.6325998,2.5,9.5,2.5L8.5,2.5L8.5,3.52125C9.9988003,3.64832,11.3954,4.333025,12.4138,5.4400501000000006C13.43215,6.54705,13.9982,7.9958,14,9.5L14,10.5L14.5,10.5C14.6326,10.5,14.7598,10.5527,14.85355,10.64645C14.9473,10.7402,15,10.8674002,15,11C15,11.1325998,14.9473,11.2598,14.85355,11.35355C14.7598,11.4473,14.6326,11.5,14.5,11.5L1.5,11.5C1.36739004,11.5,1.24021494,11.4473,1.14644504,11.35355C1.052680016,11.2598,1,11.1325998,1,11ZM14.5,12.5L1.5,12.5C1.36739004,12.5,1.24021494,12.5527,1.14644504,12.64645C1.052680016,12.7402,1,12.8674,1,13C1,13.1326,1.052680016,13.2598,1.14644504,13.35355C1.24021494,13.4473,1.36739004,13.5,1.5,13.5L14.5,13.5C14.6326,13.5,14.7598,13.4473,14.85355,13.35355C14.9473,13.2598,15,13.1326,15,13C15,12.8674,14.9473,12.7402,14.85355,12.64645C14.7598,12.5527,14.6326,12.5,14.5,12.5Z"
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
